import * as React from 'react';
import {Component} from 'react';
import EntityIcon from '../EntityIcon/EntityIcon';
import {Text} from '@priority-software/priority-style-react';
//import { LabledButton } from './LabeledButton';

export class EntityButton extends Component<any, any> {
    public render() {
        const {onClick, text, style, /*img,*/ disabled, entityType, onContextMenu} = this.props;
        return (
            <div
                title={text}
                className={`entity-button button labeled-btn ${style} ${disabled && 'disabled'}`}
                onClick={onClick}
                onContextMenu={onContextMenu && onContextMenu}
            >
                <div className="label-comp">
                    <EntityIcon type={entityType} />
                </div>
                <Text textColor="primary-700" skin="paragraph-2" componentClasses="entity-btn-body">
                    {text}
                </Text>
            </div>
        );
    }
}

export default EntityButton;
